import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import EmployeeModel from 'models/Employee';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Title from './styled/Title';
import Paragraph from './styled/Paragraph';
import FeaturedTeamWrapper from './styled/FeaturedTeamWrapper';
import FeaturedTeamMember from './styled/FeaturedTeamMember';
import TeamMembers from './styled/TeamMembers';
import TextWrapper from './styled/TextWrapper';
import Header from './styled/Header';
import Article from './styled/Article';

export default class TeamSection extends PureComponent {

  static defaultProps = {};

  static contextType = ThemeContext;

  render() {
    const { className, heading, title, paragraph1, featuredEmployees, employees,childRef } = this.props;

    return (
      <Wrapper ref={childRef} className={className}>
        <TextWrapper>
          <Header>
            <Heading theme={this.context}>{heading}</Heading>
            <Title theme={this.context}>{title}</Title>
          </Header>
          <Article>
            <Paragraph theme={this.context}>{paragraph1}</Paragraph>
          </Article>
        </TextWrapper>
        <FeaturedTeamWrapper>
          {featuredEmployees.map(
            (employee, index) =>
              <FeaturedTeamMember
                key={employee.image.url}
                flipped={index % 2 !== 0}
                {...employee}
              />
          )}
        </FeaturedTeamWrapper>
        <TeamMembers employees={employees} />
      </Wrapper>
    );
  }
}
